import { CandidatesPageFilter } from '@modules/candidates/+filter/store';
import { Tag } from 'mojo-tag';

export enum LocationType {
  city = 'CITY',
  county = 'COUNTY',
  area = 'AREA',
  state = 'STATE',
  country = 'COUNTRY',
}

export interface Location extends Tag {
  lon?: number;
  lat?: number;
  name?: string;
  countryName?: string;
  countryCode?: string;
  stateCode?: string;
  type?: LocationType;
}

export const isState = (location: Location): boolean =>
  !!location && location.type === LocationType.state;

export const isCountry = (location: Location): boolean =>
  !!location && location.type === LocationType.country;
